var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizardIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220px",
    height: "192px",
    viewBox: "0 0 220 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8D61926E-B69E-467C-807A-51FDC75FEC09@0.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.9051171,7.7844523 C18.0690119,7.7844523 8.46289753,17.3905667 8.46289753,29.2266719 C8.46289753,41.0627771 18.0690119,50.6688915 29.9051171,50.6688915 C41.7412224,50.6688915 51.3473367,41.0627771 51.3473367,29.2266719 C51.3473367,17.3905667 41.7412224,7.7844523 29.9051171,7.7844523 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.020666,17.3015436 C17.1664461,17.3015436 25.4580062,19.6887186 25.5205054,24.0469556 C22.8330399,28.295689 18.2289324,31.0989771 13.020666,31.0989771 C7.81239961,31.0989771 3.20829211,28.295689 0.520826641,24.0469556 C0.583325838,19.6887186 8.8540529,17.3015436 13.020666,17.3015436 Z M13.020666,0 C16.4789549,0 19.2705857,2.93469221 19.2705857,6.57020643 C19.2705857,10.2057207 16.4789549,13.1404129 13.020666,13.1404129 C9.56237713,13.1404129 6.77074633,10.2057207 6.77074633,6.57020643 C6.77074633,2.93469221 9.56237713,0 13.020666,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ajout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1---Ajout-Utilisateur-|-Step-02",
    transform: "translate(-849.000000, -160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Illustration",
    transform: "translate(769.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(80.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(53.597173, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Utilisateur",
    transform: "translate(20.710247, 34.279152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/account_circle_24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2201346,0.725434993 C13.4910604,0.725434993 0.725434993,13.4910604 0.725434993,29.2201346 C0.725434993,44.9492088 13.4910604,57.7148343 29.2201346,57.7148343 C44.9492088,57.7148343 57.7148343,44.9492088 57.7148343,29.2201346 C57.7148343,13.4910604 44.9492088,0.725434993 29.2201346,0.725434993 Z",
    fill: "#0046FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Black-/-Disabled",
    mask: "url(#mask-2)",
    fill: "#000000",
    fillOpacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.678445, 1.678445)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 55.749771,
    height: 55.749771
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/account_circle_24px",
    transform: "translate(15.925795, 13.890459)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-White-/-Active",
    mask: "url(#mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.062319, -13.140413)",
    id: "Rectangle-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 54.1659707,
    height: 56.9417891
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Etoile",
    fill: "#FEC55C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xC9toile",
    transform: "translate(0.000000, 3.721757)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-862",
    points: "19.0643179 19.8411318 19.8411318 -9.64128659e-15 20.6179457 19.8411318 19.0643179 19.8411318"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-863",
    points: "19.0643179 19.8411318 19.8411318 39.6822636 20.6179457 19.8411318 19.0643179 19.8411318"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-864",
    points: "19.8411318 19.0643179 39.6821492 19.8411318 19.8411318 20.6179457 19.8411318 19.0643179"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-865",
    points: "19.8411318 19.0643179 -7.71302927e-14 19.8411318 19.8411318 20.6179457 19.8411318 19.0643179"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\xC9toile",
    transform: "translate(47.142251, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-862",
    points: "9.53215894 9.9205659 9.9205659 -9.64128659e-15 10.3089729 9.9205659 9.53215894 9.9205659"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-863",
    points: "9.53215894 9.9205659 9.9205659 19.8411318 10.3089729 9.9205659 9.53215894 9.9205659"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-864",
    points: "9.9205659 9.53215894 19.8410746 9.9205659 9.9205659 10.3089729 9.9205659 9.53215894"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-865",
    points: "9.9205659 9.53215894 -7.71302927e-14 9.9205659 9.9205659 10.3089729 9.9205659 9.53215894"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Homme",
    transform: "translate(94.982332, 52.918728)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    fill: "#F8DBBD",
    points: "10.535095 43.0965345 8.32553278 40.8886508 7.39165704 41.3435337 8.95574632 43.9867683 4.48779177 44.0642861 0.0747710972 43.8390573 0 45.3050285 3.16480113 46.0451098 8.26907297 47.5597586 15.6714116 48.6498907 15.6714116 45.2009594 12.4730398 44.8211527 10.535095 43.0965345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5040604,33.6326499 C48.7492294,48.3012132 32.7756816,52.4621485 12.7919614,48.8824441 L12.7812798,44.2420582 C32.5055901,44.0929738 41.3438389,41.9093526 51.3189137,21.7684605 C53.0142339,18.3465383 60.6546192,25.7822951 56.5040604,33.6326499",
    id: "Fill-11",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9613333,17.9375862 C60.4943955,15.6657656 60.1052806,12.6877396 60.0259316,9.29526813 C59.4796449,9.26322338 58.5289838,9.20935767 58.5289838,9.20935767 C58.5289838,9.20935767 59.2675391,7.48504461 60.2822897,5.52619446 C61.2970403,3.56322427 63.0991763,2.90447564 65.8412919,3.06042679 C68.9496332,3.2404878 70.6876797,6.06439377 70.7502433,8.70671278 C70.7914437,10.5115955 73.5549224,15.1884513 74.4781166,17.7044225 C75.9063971,21.6030485 61.586969,20.9841269 60.9613333,17.9375862",
    id: "Fill-12",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1642834,6.48891048 C61.046786,6.80615357 61.2100617,7.15925626 61.5274573,7.27446479 C61.846379,7.3927252 62.1988713,7.2303651 62.3148428,6.91403758 C62.4323402,6.59557374 62.2705905,6.24292883 61.9531948,6.12558399 C61.6342732,6.00823915 61.2817809,6.17258296 61.1642834,6.48891048",
    id: "Fill-13",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5742527,6.56948016 C62.4582812,6.8876388 62.6215569,7.24013112 62.9389526,7.35930709 C63.2578742,7.47436303 63.6103665,7.31154515 63.7278639,6.99475985 C63.8438354,6.67705898 63.6820857,6.32502445 63.3631641,6.20584847 C63.0457684,6.08972438 62.6932761,6.25330523 62.5742527,6.56948016",
    id: "Fill-14",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2497347,3.50188145 C70.37181,2.08199357 68.9755742,0.824618386 67.5442418,1.00757868 C66.1098574,1.18641894 64.9562462,0.677212509 65.1591964,-3.08521171e-13 C63.8682505,0.809206385 63.6866635,2.76607281 64.7380367,3.64043687 C65.7894099,4.51312239 68.0371206,4.89842243 69.6134174,4.97166759 C69.2517695,5.67695741 69.9567541,8.62339642 70.7502433,8.70671278 C72.1663163,7.57568549 72.3372217,3.90137274 70.2497347,3.50188145",
    id: "Fill-15",
    fill: "#996341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0320359,68.4320341 C59.4048738,86.0551239 64.4145373,111.719922 66.1403763,134.589196 C66.790427,134.564781 68.670386,134.49001 69.4577715,134.459491 C71.5986664,115.73925 72.741596,91.7102604 71.169877,68.0917493 C70.4648924,57.5108761 55.5564512,57.4666238 57.0320359,68.4320341",
    id: "Fill-16",
    fill: "#004480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1876804,135.796215 C65.9008036,136.345554 64.0849341,136.968137 63.2838152,136.524089 C62.4781184,136.084618 60.7553313,136.890314 62.1622487,137.750945 C63.5691661,138.608524 66.6454627,138.318595 67.2512611,137.551047 C67.2512611,137.857761 67.2512611,138.213305 67.2512611,138.213305 L69.6668254,138.219409 L69.4226748,135.806896 L66.1876804,135.796215",
    id: "Fill-17",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2950041,68.744852 C75.4547187,96.5383369 88.7181957,118.696523 103.402324,132.58411 C103.962344,132.25298 105.579841,131.291638 106.255833,130.888789 C94.4206364,113.026127 84.3448495,88.191441 85.4297934,68.4045672 C86.0127028,57.8160642 69.6546178,57.8023308 71.2950041,68.744852",
    id: "Fill-18",
    fill: "#004480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.02033,133.623275 C104.027959,134.244333 102.726332,135.655828 101.810767,135.646673 C100.895203,135.643621 99.7644809,137.172613 101.409445,137.259592 C103.054409,137.343519 105.621042,135.623784 105.788895,134.660915 C105.935385,134.931006 106.103239,135.242298 106.103239,135.242298 L108.231926,134.096317 L106.867735,132.092757 L104.02033,133.623275",
    id: "Fill-19",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2146358,17.2013198 C73.8936813,15.6207504 53.9053833,17.6264469 51.3189137,21.7684605 C47.6749671,27.6057943 52.3061973,52.2009074 55.6953118,77.7494284 C63.8606208,77.1329483 80.2599061,75.8954103 88.1062935,75.3033453 C87.7476974,52.9647934 94.9364043,18.562459 85.2146358,17.2013198",
    id: "Fill-20",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    fill: "#FF5C35",
    points: "63.7095526 19.5373825 63.906399 17.0891632 67.0788298 16.7432324 67.5869681 19.6438932 63.7095526 19.5373825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4511598,18.6358567 L66.7278635,18.701167 C66.7278635,18.701167 66.9735399,45.8587924 67.3428176,64.4615362 C65.8489216,66.1950049 63.494395,68.667029 63.494395,68.667029 C63.494395,68.667029 61.0666232,65.6075178 59.9435308,64.2768974 C63.1007023,44.639108 64.4511598,18.6358567 64.4511598,18.6358567",
    id: "Fill-22",
    fill: "#FF5C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6342676,75.7657054 C97.3748577,76.0281672 96.9506461,76.0296931 96.6881843,75.7702832 C96.4272485,75.5093473 96.4226706,75.0851358 96.6851324,74.8241999 L98.369771,73.1304057 C98.6307069,72.8679439 99.0549184,72.8679439 99.3158543,73.1273538 C99.5798421,73.3898156 99.5798421,73.8140272 99.3173803,74.0734371 L97.6342676,75.7657054",
    id: "Fill-23",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3133117,80.772317 L96.4486116,80.7677392 L96.4364041,76.8216564 C96.43793,76.6843217 96.5218568,76.5836096 96.5951019,76.5256239 C96.7171772,76.4249118 96.8850307,76.3654001 97.0483063,76.3654001 L105.254816,76.3379332 C105.410462,76.3394591 105.558478,76.3913411 105.662242,76.4828975 C105.75685,76.5683502 105.80568,76.6705883 105.807206,76.7926635 L105.817888,80.7387463 L106.954714,80.7341685 L106.94098,76.7880857 C106.939454,75.8969363 106.197847,75.2011073 105.254816,75.2041492 L97.0452545,75.2285742 C96.6210429,75.2301002 96.1937795,75.3826943 95.871806,75.6482079 C95.5010024,75.9533961 95.2980523,76.3715039 95.3010702,76.8247083 L95.3133117,80.772317",
    id: "Fill-24",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.970996,95.0215518 C113.974041,96.2850308 112.953187,97.3119889 111.688182,97.3165667 L90.7507488,97.3852494 C89.4872699,97.3898119 88.4587858,96.3689575 88.454208,95.1039526 L88.4099489,81.4879832 C88.4069038,80.2245043 89.4262322,79.1975462 90.6897112,79.1929683 L111.630196,79.1242857 C112.893675,79.1197232 113.922159,80.1405775 113.925211,81.4040565 L113.970996,95.0215518",
    id: "Fill-25",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.630196,79.1242857 L90.6897112,79.1929683 C89.4262322,79.1975462 88.4069038,80.2245043 88.4099489,81.4879832 L88.428267,87.1461716 L113.943522,87.0607189 L113.925211,81.4040565 C113.922159,80.1405775 112.893675,79.1197232 111.630196,79.1242857",
    id: "Fill-26",
    fill: "#002C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.08442,85.1166606 C100.199374,85.1181963 99.4852337,85.8384403 99.4882759,86.72196 L99.4943894,88.1731297 C99.4943894,89.0551235 100.216159,89.7723156 101.099679,89.7692734 C101.983199,89.7646859 102.698865,89.0459678 102.695823,88.1624481 L102.691235,86.7128044 C102.688183,85.8277588 101.967939,85.1136185 101.08442,85.1166606",
    id: "Fill-27",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.726841,86.9966294 C101.722263,86.6471889 101.436912,86.3648899 101.087472,86.3648899 C100.738031,86.3664158 100.455732,86.6502408 100.455732,87.0012072 C100.455732,87.2300983 100.580859,87.4299965 100.762446,87.5413902 L100.763972,88.191441 C100.767024,88.3745539 100.913514,88.5195183 101.095101,88.5195183 C101.276688,88.5195183 101.424704,88.371502 101.423178,88.189915 L101.421653,87.5383383 C101.604765,87.4269447 101.726841,87.2255205 101.726841,86.9966294",
    id: "Fill-28",
    fill: "#002C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.374354,77.9081262 C104.375874,78.2758779 104.078315,78.5780142 103.709038,78.5810661 C103.338234,78.5810661 103.037624,78.2819817 103.037624,77.9111781 L103.034572,75.9686555 C103.03152,75.5993778 103.330604,75.2987617 103.702934,75.2987617 C104.072212,75.2972416 104.372822,75.5948 104.374354,75.9656036 L104.374354,77.9081262",
    id: "Fill-29",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36977,73.7270485 C104.366718,73.2829998 104.008122,72.9274556 103.568651,72.9289766 L98.9267394,72.9335593 C98.4857425,72.9335593 98.1271465,73.2921554 98.1316809,73.7362042 L98.1332502,76.6812698 C98.1347762,77.1237927 98.4872685,77.4823887 98.9343691,77.4808677 L103.574755,77.474759 C104.015752,77.474759 104.374348,77.114637 104.374348,76.6751661 L104.36977,73.7270485",
    id: "Fill-30",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4715003,77.9218597 C99.4715003,78.2896114 99.1724159,78.5917535 98.8046642,78.5917535 C98.4338606,78.5932736 98.1332502,78.2926633 98.1332502,77.9249116 L98.1317184,75.980863 C98.1301983,75.6100594 98.4277568,75.312501 98.8000863,75.3094491 C99.1678381,75.3094491 99.4684484,75.6070075 99.4684484,75.9778112 L99.4715003,77.9218597",
    id: "Fill-31",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.105783,77.9157559 C101.108835,78.2865595 100.808224,78.5871757 100.437421,78.5871757 C100.071195,78.5886958 99.7675328,78.2896114 99.7675328,77.9218597 L99.766001,75.9778112 C99.7644809,75.6070075 100.063565,75.3079232 100.432843,75.3063914 C100.803647,75.3048713 101.102731,75.6054816 101.102731,75.9747593 L101.105783,77.9157559",
    id: "Fill-32",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.741597,77.91423 C102.743117,78.2819817 102.442507,78.5841238 102.073229,78.5841238 C101.703952,78.5856439 101.403341,78.2850336 101.401815,77.9157559 L101.400284,75.9732333 C101.398763,75.6024297 101.697848,75.3033453 102.068651,75.3018136 C102.437929,75.3002935 102.738539,75.6009038 102.738539,75.9701814 L102.741597,77.91423",
    id: "Fill-33",
    fill: "#F8DBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2334554,18.1499972 C105.445558,33.3118971 106.255833,58.3165728 103.568651,72.9289815 L98.9267394,72.9335593 C99.4715003,57.4269493 98.0783164,44.2565546 81.9292853,29.6378896 C77.635288,25.7496399 83.5940867,15.120547 87.2334554,18.1499972",
    id: "Fill-34",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    fillOpacity: 0.1,
    fill: "#000000",
    x: 50.8833922,
    y: 138.402827,
    width: 73.95053,
    height: 1,
    rx: 0.339222615
  })), /*#__PURE__*/React.createElement("g", {
    id: "Femme",
    transform: "translate(0.000000, 55.632509)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-35",
    fill: "#DEBB96",
    points: "25.4292993 73.8318177 25.324114 50.3308656 29.9672939 39.8993382 32.8238264 41.3300086 28.2467629 51.2090126 28.4586361 73.9490241 25.4292993 73.8318177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4821032,96.2242669 C41.745043,99.7194243 20.3924257,133.80848 20.3924257,133.80848 L20.9018231,130.176581 C24.3263562,124.980427 27.7824449,116.810534 29.7494101,110.446823 C31.7163753,104.084615 32.6299849,102.619534 33.4278905,101.614263 C34.2257962,100.610494 37.1514504,96.2242669 37.1514504,96.2242669 L43.4821032,96.2242669",
    id: "Fill-36",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1415071,128.170547 C22.1415071,128.170547 21.119707,127.821933 20.3638754,128.263711 C20.1414836,129.770867 18.6027729,133.175865 18.6027729,133.175865 L19.0430485,133.411781 L22.1415071,128.170547",
    id: "Fill-37",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-38",
    fill: "#4965FF",
    points: "20.3924257 133.80848 23.2519634 135.661244 20.9964899 132.825748 20.3924257 133.80848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4122888,95.7884992 C48.52649,99.6893714 46.3461489,135.374238 46.3461489,135.374238 L45.0839252,131.931673 C45.6579364,125.734756 44.8555228,116.900693 43.5932991,110.359669 C42.3310754,103.820149 42.4452766,102.099618 42.673679,100.837394 C42.903584,99.5736676 43.8232042,95.7884992 43.8232042,95.7884992 L48.4122888,95.7884992",
    id: "Fill-39",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2341899,129.578528 C45.2341899,129.578528 44.1673104,129.751332 43.7075003,130.496645 C44.224411,131.931673 44.4693425,135.661244 44.4693425,135.661244 L44.9712267,135.661244 L45.2341899,129.578528",
    id: "Fill-40",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-41",
    fill: "#4965FF",
    points: "46.3461489 135.374238 49.7421316 135.661244 46.4167733 134.22321 46.3461489 135.374238"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-42",
    fill: "#DEBB96",
    points: "60.2636676 45.0224637 76.0760246 30.809825 78.0985877 32.6679986 59.900027 49.1999733 54.3958302 43.0464826 56.164446 39.9589933 60.2636676 45.0224637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7585199,61.3914011 C36.5128253,63.5972873 32.9906202,65.038326 31.6382377,71.1586082 C30.2843525,77.2773878 34.8418816,98.1686924 34.8418816,98.1686924 L48.5760774,98.3264703 C48.5760774,98.3264703 47.4085205,65.9143693 46.7909325,62.1382168 C46.1718418,58.3635669 38.4347112,60.1922886 37.7585199,61.3914011",
    id: "Fill-43",
    fill: "#FF5C35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-44",
    fill: "#54274B",
    points: "44.4663372 23.8715016 58.0127021 41.0874813 54.9953864 44.5007446 42.2379113 29.8291974 44.4663372 23.8715016"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-45",
    fill: "#4965FF",
    points: "44.4663372 23.8715016 58.0127021 41.0874813 54.9953864 44.5007446 42.2379113 29.8291974 44.4663372 23.8715016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4565582,23.9116223 C42.1086837,23.9116223 38.7532724,23.923343 37.2220748,23.923343 C32.2933919,35.2088248 43.785638,53.0297703 35.8035758,62.589011 C37.9478534,62.589011 44.9712267,62.589011 47.1260228,62.589011 C45.638402,59.2230812 46.3716939,47.0959666 47.0914619,40.889733 C48.7022998,40.0204515 44.3791836,27.3891988 43.4565582,23.9116223",
    id: "Fill-46",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2514586,0.858759648 C46.8555463,2.00828479 44.3731731,15.608745 48.3311459,18.4226022 C45.7180423,18.4226022 38.8674736,18.4226022 37.0447625,18.4226022 C37.0447625,3.75345929 41.0883862,-0.538101228 44.2514586,0.858759648",
    id: "Fill-47",
    fill: "#FCE597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0838548,15.6185122 C33.8711715,11.2440055 36.1011,4.4882538 38.8719815,2.33691374 C41.10191,0.602858823 43.0313091,0.748465341 44.4437975,1.32097394 C46.745853,2.25531999 49.6745125,9.51806491 49.6745125,9.51806491 L47.9780238,9.51415803 C47.9780238,9.51415803 48.3311459,12.0023916 46.3356303,14.3896473 C44.7413216,16.2984601 42.2379113,16.7540627 41.7225033,23.8715016 C41.5241539,26.6091746 39.9794325,24.7813545 39.5391569,23.9116223 C40.1387131,19.2822667 40.4662902,16.7784056 39.0838548,15.6185122",
    id: "Fill-48",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8104434,1.68461457 C45.7030159,3.96398017 42.8675205,5.93410097 40.3641102,8.34269424 C37.7690384,10.8385913 39.7555381,16.4947058 41.5046195,18.4226022 C38.856955,18.4226022 35.5631523,18.4226022 33.4970123,18.4226022 C31.0311682,12.0937525 35.9162744,2.16606275 38.8960239,0.648389034 C41.5256565,-0.691521511 46.3100853,-0.158682799 47.0268481,4.18817514 C46.3641806,3.13061201 45.5181902,2.10370289 44.8104434,1.68461457",
    id: "Fill-49",
    fill: "#FCE597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2220748,23.9116223 C35.3602949,23.9116223 25.4848972,47.0803391 25.4848972,47.0803391 L30.2828499,49.3001998 C30.2828499,49.3001998 37.2881913,34.3523159 37.7945834,33.0666509 C38.3009755,31.7814367 39.0853574,23.9116223 37.2220748,23.9116223",
    id: "Fill-50",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-51",
    fill: "#DEBB96",
    points: "43.1515208 23.9116223 43.2236479 27.1091054 45.3979785 36.7416753 42.0891492 27.0320196 38.7532724 23.9116223 43.1515208 23.9116223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4663372,23.8715016 C45.3513964,27.0273614 47.7406055,35.7263365 50.2154655,36.8645918 C50.1884179,37.4796253 50.0757193,38.0752747 49.8818778,38.6196838 L45.9960321,33.9194032 L44.4663372,23.8715016",
    id: "Fill-52",
    fill: "#FF5C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7532724,23.9116223 L46.2064027,37.0596354 L43.4565582,23.9116223 L44.4663372,23.8715016 C44.4663372,23.8715016 47.1260228,35.7347513 49.9464917,37.0291317 C49.8668514,38.7356881 48.9126704,40.528196 47.0914619,40.889733 C46.5069321,47.5891354 47.8758438,59.6843939 47.9840344,63.5927793 C46.4363077,63.5927793 35.1258819,63.5927793 33.0642499,63.5927793 C38.7532724,59.3628274 37.5361281,43.9280857 35.8035758,34.6699755 C36.7742859,28.1155785 37.2220748,23.923343 37.2220748,23.923343 L38.7532724,23.9116223 Z",
    id: "Fill-53",
    fill: "#4965FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-54",
    fill: "#FF5C35",
    points: "45.0193114 36.2796112 38.9320874 30.7733107 40.1657608 28.8282841 37.7945834 29.0333954 37.7990914 28.987715 38.1146473 24.4343933 38.1927849 24.4395023 37.8787317 28.947444 40.3175281 28.7363221 39.0342674 30.7594863 45.0704014 36.2213085 45.0193114 36.2796112"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#002C52",
    points: "14.9257951 96.0995471 39.2596645 96.0995471 39.2596645 78.6793577 14.9257951 78.6793577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.105514,74.0842624 C27.8996513,74.2750986 27.8861275,74.5981677 28.0769637,74.8055331 L29.1994412,76.0166667 C29.3917801,76.2240321 29.7148492,76.2345506 29.9192092,76.045217 L29.9207119,76.0437144 C30.1265746,75.8528782 30.1385957,75.5313117 29.9477595,75.3239464 L28.825282,74.1128127 C28.6329432,73.9054474 28.3113767,73.8934262 28.105514,74.0842624",
    id: "Fill-56",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9613068,80.3638252 L31.0086285,80.3578146 L31.0311682,77.0474828 C31.0326708,76.8311015 30.7606917,76.6658104 30.5187655,76.6643077 L23.6351385,76.6207309 L23.6321332,76.6207309 C23.4082387,76.6207309 23.1768311,76.7604771 23.1738258,76.9978954 L23.1527887,80.3082273 L22.2001104,80.3022167 L22.2211474,76.9933874 C22.2256554,76.2480744 22.844746,75.6680526 23.6321332,75.6680526 L23.6411491,75.6680526 L30.5247761,75.7116294 C31.3316976,75.7161373 31.9868518,76.3186988 31.9838568,77.0534933 L31.9613068,80.3638252",
    id: "Fill-57",
    fill: "#002C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8883463,74.3337018 C24.9003674,74.0436909 25.140791,73.8197965 25.4292993,73.8318177 L28.4586361,73.9490241 C28.7456417,73.9610453 28.9710388,74.2029715 28.9605203,74.4914798 L28.8989118,76.0587409 C28.8883932,76.3472491 28.6449644,76.5726462 28.3564561,76.560625 L25.3301246,76.4434186 C25.0401136,76.4313974 24.8162192,76.1894712 24.8267377,75.8994603 L24.8883463,74.3337018",
    id: "Fill-58",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8801169,76.019672 C27.8921381,75.738677 27.6727516,75.5012587 27.3917566,75.4907402 C27.1107615,75.4802217 26.8748459,75.6981055 26.8643274,75.9806032 L26.8237559,77.0174298 C26.8117347,77.2984248 27.0326239,77.5343405 27.3121163,77.5463616 L27.3121163,77.544859 C27.5946139,77.5568802 27.8305296,77.3374937 27.8410481,77.0564986 L27.8801169,76.019672",
    id: "Fill-59",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8989118,76.0587409 C28.9094303,75.7792485 28.6900438,75.5418302 28.4090488,75.529809 C28.1295564,75.5192905 27.8921381,75.738677 27.8801169,76.019672 L27.8410481,77.0564986 C27.8305296,77.3374937 28.0499161,77.5734093 28.3294085,77.5854305 C28.6119061,77.595949 28.8478217,77.3765625 28.8583403,77.0970701 L28.8989118,76.0587409",
    id: "Fill-60",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3729617,75.4516714 C26.0919667,75.4411528 25.8560511,75.6590367 25.8455326,75.9415344 L25.8049611,76.978361 C25.7944426,77.259356 26.0138291,77.4952716 26.2933214,77.5072928 C26.5743165,77.5163087 26.8117347,77.2984248 26.8222533,77.0174298 L26.8643274,75.9806032 C26.8748459,75.6996082 26.6554594,75.4621899 26.3729617,75.4516714",
    id: "Fill-61",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8455326,75.9415344 C25.8560511,75.6605393 25.6366646,75.4231211 25.3556696,75.4126026 C25.0746745,75.402084 24.8372563,75.6199679 24.8267377,75.8994603 L24.7876689,76.9377895 C24.7756477,77.2202872 24.9935316,77.4547002 25.2760293,77.4652187 C25.5570243,77.4772399 25.7944426,77.259356 25.8049611,76.978361 L25.8455326,75.9415344",
    id: "Fill-62",
    fill: "#DEBB96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#FFFFFE",
    points: "24.416515 89.4127669 27.8410481 89.4127669 27.8410481 88.1595591 24.416515 88.1595591"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-64",
    fill: "#4965FF",
    points: "37.4594931 89.4518357 15.5914678 89.4518357 15.5914678 89.3736981 37.3813554 89.3736981 37.3813554 79.8559304 37.4594931 79.8559304 37.4594931 89.4518357"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-65",
    fill: "#DEBB96",
    points: "75.7830083 29.9585753 75.5050186 31.3458193 78.0985877 32.6679986 81.8537032 32.0562709 84.1272085 31.7936082 84.1272085 31.2257578 81.1639881 31.0404814 78.5508846 30.35287 80.2353521 29.2108581 79.7424838 28.6831284 77.7469683 29.3878699 75.7830083 29.9585753"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-76",
    transform: "translate(43.920876, 5.691273)",
    fill: "#54274B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93316742,0.745914091 C2.93316742,1.07980231 2.66269091,1.35042908 2.32760058,1.35042908 C1.99401289,1.35042908 1.72353639,1.07980231 1.72353639,0.745914091 C1.72353639,0.412025874 1.99401289,0.141399105 2.32760058,0.141399105 C2.66269091,0.141399105 2.93316742,0.412025874 2.93316742,0.745914091",
    id: "Fill-73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24268927,0.745914091 C1.24268927,1.07980231 0.972212765,1.35042908 0.638625078,1.35042908 C0.30503739,1.35042908 0.0330582393,1.07980231 0.0330582393,0.745914091 C0.0330582393,0.412025874 0.30503739,0.141399105 0.638625078,0.141399105 C0.972212765,0.141399105 1.24268927,0.412025874 1.24268927,0.745914091",
    id: "Fill-75"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    fillOpacity: 0.1,
    fill: "#000000",
    x: 0,
    y: 135.689046,
    width: 61.7385159,
    height: 1,
    rx: 0.339222615
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardIllustration);
export default __webpack_public_path__ + "static/media/WizardIllustration.a60c69ca7f2c5d116f379609c69cb97e.svg";
export { ForwardRef as ReactComponent };